import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from './reducer';
import { IHeaderActions } from './models';
import { flow, forEach } from 'lodash';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { II18nMessages } from '../../../../services/branding/models';
import QuoteWizardNavigation from './components/QuoteWizardNavigation';
import { withRouter } from 'react-router';
import { IChannel } from '../../../../data/api/models';

const groupSure = require('./groupsure_logo.png');
const salt = require('./salt_logo.png');
const procycle = require('./pro-cycle.png');

interface IProps {
  classes: any;
  isDrawerOpened: boolean;
  i18n: II18nMessages;
  actions: {
    header: IHeaderActions;
  };
  steps: object;
  location: any;
  channel: IChannel;
}

class Header extends React.Component<IProps, any> {

  private renderWizardNavigation = () => {
    const { steps, location, i18n } = this.props;

    let currentStep = '';
    let isInQuoteProcess = false;

    forEach(steps, (step) => {
      if (step.route === location.pathname) {
        currentStep = step.key;
        isInQuoteProcess = true;
      }
    });

    if (isInQuoteProcess) {
      return (
        <QuoteWizardNavigation i18n={i18n} steps={steps} currentStep={currentStep} />
      );
    }
  }

  public render() {
    const { i18n, steps, location, channel } = this.props;

    let currentStep = '';

    forEach(steps, (step) => {
      if (step.route === location.pathname) {
        currentStep = step.key;
      }
    });

    let logo = salt;

    if (channel.key.indexOf('groupsure') > -1) {
      logo = groupSure;
    }

    if (channel.key === 'procycle-b2c') {
      logo = procycle;
    }

    return (
      <header>
        <div className="container">
          <Row>
            <Col sm={6} className="logo-container">
              <Link to="/">
                <img src={logo} alt={i18n.siteName} />
              </Link>
            </Col>
            <Col sm={6} className="extra-info">
              <div className="phone">
                {channel.phone}
              </div>
              <div className="hours">
                {channel.openingHours}
              </div>
              {channel.email && (
                <div className="hours">
                  {channel.email}
                </div>
              )}
            </Col>
          </Row>
        </div>
        {this.renderWizardNavigation()}
      </header>
    );
  }
}

export default flow([
  connect(
    (state) => ({
      isDrawerOpened: state.header.isDrawerOpened,
      i18n: state.branding.i18n,
      channel: state.branding.channel,
    }),
    (dispatch) => ({
      actions: {
        header: bindActionCreators({ ...actions }, dispatch),
      },
    }),
  ),
  withRouter,
])(Header);
